import React, { useState, useEffect } from 'react';
import { Package } from 'lucide-react';
import { siteService } from '../api/siteService';
import Table from '../components/Common/Table';
import Modal from '../components/Common/Modal';
import SiteForm from '../components/Sites/SiteForm';
import SiteProductManager from '../components/Sites/SiteProductManager';
import '../components/Common/Common.css';

function SitesVitrines() {
  const [sites, setSites] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [editingSite, setEditingSite] = useState(null);
  const [managingSite, setManagingSite] = useState(null);

  const fetchSites = async () => {
    try {
      setLoading(true);
      const data = await siteService.getSites();
      setSites(data);
    } catch (error) {
      console.error('Error fetching sites:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { fetchSites(); }, []);

  const handleDelete = async (id) => {
    if (window.confirm('Supprimer ce site ? Les produits/sliders assignés seront détachés.')) {
      try {
        await siteService.deleteSite(id);
        fetchSites();
      } catch (error) {
        alert('Échec de la suppression : ' + (error.response?.data?.message || error.message));
      }
    }
  };

  const handleEdit = (site) => { setEditingSite(site); setShowForm(true); };
  const handleCreate = () => { setEditingSite(null); setShowForm(true); };
  const handleFormSuccess = () => { setShowForm(false); setEditingSite(null); fetchSites(); };

  const columns = [
    { key: 'name', label: 'Nom' },
    { key: 'key', label: 'Clé', render: (v) => <code style={{ background: '#f7fafc', padding: '2px 6px', borderRadius: 4 }}>{v}</code> },
    { key: 'domain', label: 'Domaine', render: (v) => v || <span style={{ color: '#a0aec0' }}>—</span> },
    { key: 'products_count', label: 'Produits', render: (v) => v ?? 0 },
    { key: 'sliders_count', label: 'Sliders', render: (v) => v ?? 0 },
    {
      key: 'is_active',
      label: 'Statut',
      render: (v) => <span className={`badge ${v ? 'badge-success' : 'badge-danger'}`}>{v ? 'Actif' : 'Inactif'}</span>,
    },
  ];

  return (
    <div>
      <div className="page-header">
        <h1>Sites vitrines</h1>
        <button onClick={handleCreate} className="btn btn-primary">Ajouter un site</button>
      </div>

      <p style={{ color: '#718096', marginTop: -8, marginBottom: 20, maxWidth: 720 }}>
        Chaque site vitrine (Carlinkit, Azdome, …) est un storefront autonome qui utilise
        le catalogue et les commandes de Tech360. Gérez ici ses produits, ses pixels, son
        domaine et ses coordonnées. Les sliders se gèrent depuis la page « Sliders ».
      </p>

      <Table
        columns={columns}
        data={sites}
        loading={loading}
        onEdit={handleEdit}
        onDelete={handleDelete}
        customActions={(row) => (
          <button
            onClick={() => setManagingSite(row)}
            className="icon-btn icon-btn--accent"
            title="Gérer les produits"
            aria-label="Gérer les produits"
          >
            <Package size={16} />
          </button>
        )}
      />

      <Modal
        isOpen={showForm}
        onClose={() => setShowForm(false)}
        title={editingSite ? 'Modifier le site' : 'Ajouter un site'}
      >
        <SiteForm site={editingSite} onSuccess={handleFormSuccess} onCancel={() => setShowForm(false)} />
      </Modal>

      <Modal
        isOpen={!!managingSite}
        onClose={() => { setManagingSite(null); fetchSites(); }}
        title={managingSite ? `Produits — ${managingSite.name}` : ''}
        size="large"
      >
        {managingSite && (
          <SiteProductManager
            site={managingSite}
            onClose={() => { setManagingSite(null); fetchSites(); }}
          />
        )}
      </Modal>
    </div>
  );
}

export default SitesVitrines;
